"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DropInfo = /** @class */ (function () {
    function DropInfo(node, rect, location, index, className) {
        this.node = node;
        this.rect = rect;
        this.location = location;
        this.index = index;
        this.className = className;
    }
    return DropInfo;
}());
exports.default = DropInfo;
//# sourceMappingURL=DropInfo.js.map